module.exports = __webpack_public_path__ + "static/img/404.244a03e.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/404.png
// module id = 6W/Q
// module chunks = 1